<template>
<div>
<v-btn absolute dark fab top right color="primary" style="top:10px;" @click="requestCreditDialog = true">
    <v-icon color="black">add</v-icon>
</v-btn>
<requestCreditForm :dialog="requestCreditDialog" @setDialog="requestCreditDialog = $event"/>
<v-data-table :headers="headers" :items="users" :pagination.sync="pagination">
    <template slot="items" slot-scope="props">
    <td class="text-xs-center">{{ props.item.num }}</td>
    <td class="text-xs-center">{{ props.item.date }}</td>
    <td class="text-xs-center">{{ props.item.time }}</td>
    <td class="text-xs-center">{{ props.item.name }}</td>
    <td class="text-xs-center">{{ props.item.credit }}</td>
    <td class="text-xs-center">{{ props.item.status }}</td>
    <!-- <td class="justify-center layout px-0">
        <v-tooltip top>
            <v-btn icon @click="viewRequestCash()" slot="activator">
            <v-icon small>
            remove_red_eye
            </v-icon>
            </v-btn>
            <span>View</span>
        </v-tooltip>
    </td> -->
</template>

<template slot="no-data">
    <v-btn color="primary" @click="initialize">Reset</v-btn>
</template>

</v-data-table>

 <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
</div> -->
  </div>
</template>

<script>
import requestCreditForm from './RequestCreditForm'
    export default {
        data: () => ({
            requestCreditDialog : false,
            dialog: false,
            pagination: {
                rowsPerPage:10
            },
            headers: [
                {
                    text: 'No.',
                    align: 'center',
                    sortable: false,
                    value: 'num'
                },
                {
                    text: 'Date',
                    align: 'center',
                    value: 'date',
                    sortable: false,
                },
                {
                    text: 'Time',
                    align: 'center',
                    value: 'time',
                    sortable: false,
                },
                {
                    text: 'Name',
                    align: 'center',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Credit',
                    align: 'center',
                    value: 'credit',
                    sortable: false,
                },
                {
                    text: 'Status',
                    align: 'center',
                    value: 'status',
                    sortable: false,
                }
            ]
           
        }),
        components:{
            requestCreditForm
        },
        computed: {
            pages () {
                if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
                ) return 0

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        },
    
        watch: {
            dialog(val) {
                val || this.close()
            }
        },
    
        created() {
            this.initialize()
        },
    
        methods: {
            initialize() {
                this.users = [{
                        num: '1',
                        date: '12/04/2019',
                        time: '15.15',
                        name: 'Nynk Krittapohn',
                        credit: '60',
                        // type: 'แจ้งโอนเงิน',
                        status: 'Accepted',
                        // action: ''
                    }
                ]
            },
            // viewRequestCash() {
            // this.requestCreditDialog = true;
            // }
        }
    }
</script>

